export const LINE_ITEMS_ID_QUERY_PARAM = 'clid'
export const VARIANT_QUANTITY_MAP_QUERY_PARAM = 'vq'

export const PERSONALIZATION_IMAGE__FRONT_VIEW_ID = 'FRONT'
export const PERSONALIZATION_IMAGE_BACK_VIEW_ID = 'BACK'

export const SCALE_PERCENT_KEY = 'scalePercent'
export const LOGO_WIDTH_KEY = 'logoWidth'
export const LOGO_HEIGHT_KEY = 'logoHeight'
export const LOGO_DIMENSION_UNIT_KEY = 'logoDimensionUnit'
export const METHOD_NAME_KEY = 'methodName'
export const PLACEMENT_LABEL_KEY = 'placementLabel'

export const DEFAULT_SCALE_PERCENT = 80

export const CUSTOMIZATION_PAGE_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
}
